"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * SDK version.
 */
const VERSION = "2.0.0";
console.log(`Zappar for BabylonJS v${VERSION}`);
exports.default = VERSION;
